import * as amplitude from '@amplitude/analytics-browser';
import { UserLoginData } from '../models';

const trackingEnabled = process.env.REACT_APP_AMPLITUDE_TRACKING_ENABLED;
const crossDomainTrackingEnabled = process.env.REACT_APP_CROSS_DOMAIN_AMPLITUDE_TRACKING_ENABLED;

export const initAmplitude = () => {
  const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
  if (apiKey && trackingEnabled) {
    amplitude.init(apiKey, {
      autocapture: {
        attribution: false,
        pageViews: {
          trackHistoryChanges: 'all',
        },
        sessions: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: true,
      },
    });
  }
};

export const initCrossDomainAmplitude = () => {
  const apiKey = process.env.REACT_APP_CROSS_DOMAIN_AMPLITUDE_API_KEY;
  if (apiKey && crossDomainTrackingEnabled) {
    amplitude.init(apiKey, {
      autocapture: {
        attribution: false,
        pageViews: {
          trackHistoryChanges: 'all',
        },
        sessions: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: true,
      },
    });
  }
};

export const setAmplitudeIdentity = (userData: UserLoginData) => {
  const identifyEvent = new amplitude.Identify();
  identifyEvent.set('isSynergyUser', userData.isSynergyUser);
  identifyEvent.set('synergyAccountType', userData.accounts[0].role.name);
  identifyEvent.set('partnerships', userData.partnershipsCount);
  identifyEvent.set('subPartnerships', userData.subPartnershipsCount);
  identifyEvent.set('synergyTotalClients', userData.synergyTotalClientsCount);
  identifyEvent.set('synergyDirectClients', userData.synergyDirectClientsCount);
  identifyEvent.set('synergyIndirectClients', userData.synergyIndirectClientsCount);
  amplitude.identify(identifyEvent);
};

export const setCrossDomainAmplitudeIdentity = (userData: UserLoginData, partnerships: string[], domain: string) => {
  const identifyEvent = new amplitude.Identify();
  identifyEvent.set('has_lifetime_commission', userData.hasLifetimeCommission);
  identifyEvent.set('has_commission_last_calendar_month', userData.hasLastMonthCommission);
  identifyEvent.set('has_commission_last_3_months', userData.hasLastThreeMonthCommission);
  identifyEvent.set('partner_hub_uid', userData.userID);
  identifyEvent.set('partner_IBs_ids', partnerships);
  identifyEvent.set('domain', domain);
  amplitude.identify(identifyEvent);
};

export const trackAmplitudeData = (eventType: string | amplitude.Types.BaseEvent, eventProperties?: Record<string, unknown>) => {
  if (trackingEnabled) {
    amplitude.track(eventType, eventProperties);
  }
};
